/** Variantli qadamlar: rec (tarjimani tanlash), recUz (so'zni tanlash), listen (eshitib tanlash). */
import { useEffect, useState } from 'react';
import { distract, LN, POS, shuffle } from '../../../data';
import { t } from '../../../i18n';
import { speak } from '../../../lib/speech';
import { Ic } from '../../../ui/Icon';
import type { Step } from '../engine';
import { answer, Frame, Options, Prompt } from './common';

export function ChoiceStep({ s }: { s: Step }) {
  const w = s.w!;
  const enQ = s.t === 'rec', key = enQ ? 'uz' : 'w';
  const [opts] = useState(() => shuffle([w, ...distract(w, key)]));
  const [picked, setPicked] = useState<number | null>(null);
  useEffect(() => { if (s.t === 'listen' && s.stage !== 4) speak(w.w); }, [w.id]); // eslint-disable-line
  const pick = (i: number) => { if (picked !== null) return; setPicked(i); answer(w, opts[i]!.id === w.id); };

  return (
    <Frame>
      {s.t === 'listen' ? (
        <>
          <Prompt retry={s.retry} text={s.stage === 4 ? 'Tugmani bosib eshiting va qaysi soʻz ekanini tanlang' : 'Eshiting va qaysi soʻz ekanini tanlang'} />
          <div className="ask">
            <button className="spk" id="au" style={{ width: 72, height: 72, borderRadius: 24 }} aria-label={t('Qayta eshitish')} onClick={() => speak(w.w)}><Ic n="vol" style={{ width: 32, height: 32 }} /></button>
            <span className="t13">{t('Tugmani bosib, yana eshiting')}</span>
          </div>
          {s.note ? <div className="note"><Ic n="head" /><span>{t(s.note)}</span></div> : null}
        </>
      ) : (
        <>
          <Prompt retry={s.retry} text={enQ ? 'Toʻgʻri tarjimani tanlang' : LN.Adj + 'sini tanlang'} />
          <div className="ask">
            {enQ && <button className="spk" id="au" aria-label={t('Tinglash')} onClick={() => speak(w.w)}><Ic n="vol" /></button>}
            <div className="col">
              <div className="word">{enQ ? w.w : w.uz}</div>
              {enQ ? <span className="t13" style={{ fontSize: 14 }}>{w.ipa}</span> : <span className="t13" style={{ fontSize: 14 }}>{POS[w.pos] || ''}</span>}
            </div>
          </div>
        </>
      )}
      <Options opts={opts} label={(o) => o[key]} answerId={w.id} picked={picked} onPick={pick} />
    </Frame>
  );
}
